import { fg } from '@confluence/feature-gating';

import { FORGE_MODULE_ATTACHMENT_ACTION } from './ForgeModuleType.ts';
import type {
	AttachmentActionSurface as AttachmentActionSurfaceType,
	Extension,
	ForgeUIAttachmentActionExtensionDataType,
} from './types.ts';

export type AttachmentActionSurface = AttachmentActionSurfaceType;

export type ForgeUIAttachmentActionExtensionType = Extension & {
	properties: Extension['properties'] & {
		icon?: string;
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- Forge manifest field, not the browser `location` global
		location: 'action';
		title: string;
	};
};

export type AttachmentActionContext = {
	attachmentId: string;
	content: ForgeUIAttachmentActionExtensionDataType['content'];
	space: ForgeUIAttachmentActionExtensionDataType['space'];
	surface: AttachmentActionSurfaceType;
};

export const filterAttachmentActionExtensions = (
	extensions: ReadonlyArray<Extension>,
): ForgeUIAttachmentActionExtensionType[] => {
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (!fg('forge_attachment_action')) {
		return [];
	}

	return extensions.filter(
		(extension): extension is ForgeUIAttachmentActionExtensionType =>
			extension.type === FORGE_MODULE_ATTACHMENT_ACTION &&
			extension.properties.location === 'action',
	);
};

export const createAttachmentActionExtensionData = ({
	attachmentId,
	content,
	space,
	surface,
}: AttachmentActionContext): ForgeUIAttachmentActionExtensionDataType => ({
	type: FORGE_MODULE_ATTACHMENT_ACTION,
	attachment: { id: attachmentId },
	attachmentActionLocation: 'action',
	content,
	space,
	surface,
});
